// React
import React from "react";

// Libraries
import ScrollableAnchor from 'react-scrollable-anchor';

import './login.css';
import './howitworks.css';

export const HowItWorks = () => {

    return (
        <ScrollableAnchor id={'how-it-works'}>
            <div className="section">

                <div className="section-title">How It Works</div>

                <div className="section-content">

                    <div className="howitworks">

                        <div className="steps">

                            <div className="step">
                                <div className="number topline">
                                    <div className="badge">1</div>
                                </div>
                                <div className="content">
                                    <div className="stepTitle">Connect Your Accounts</div>
                                    <div className="stepDescription">Generate api keys from all of your exchanges and store them securely with us.</div>
                                </div>
                            </div>
                            <div className="step">
                            <div className="number middleline">
                                    <div className="badge">2</div>
                                </div>
                                <div className="content">
                                    <div className="stepTitle">See The Bigger Picture</div>
                                    <div className="stepDescription">Discover insights into your trading patterns with Yety's dashboard.</div>
                                </div>
                            </div>
                            <div className="step">
                            <div className="number bottomline">
                                    <div className="badge">3</div>
                                </div>
                                <div className="content">
                                    <div className="stepTitle">Enjoy The Benefits</div>
                                    <div className="stepDescription">Experience smarter, simplified, stress-free trading.</div>
                                    {/*<div className="stepDescription">Experience smarter, simplified, stress-free trading.</div>*/}{}
                                </div>
                            </div>

                        </div>

                        <div className="cartoon1 hover-cartoon">
                        </div>

                    </div>

                </div>

            </div>
        </ScrollableAnchor>
    );

};


// WEBPACK FOOTER //
// ./src/Views/Login/HowItWorks.js